module.exports = __webpack_public_path__ + "img/yzm8.a2ace060.png";